import { createFieldSelectorHook } from 'src/lib/sweetState';

import { WorkspaceStore } from './WorkspaceStore';

export const useWorkspacesFetched = createFieldSelectorHook(WorkspaceStore, 'workspacesFetched');
